// Heavily inspired by ngTransclude but w/ 'replace' semantics.
// @ngInject
export function transcludeReplace($compile: ng.ICompileService): ng.IDirective {
  return {
    terminal: true,
    restrict: "EA",
    compile: (tElement: ng.IRootElementService) => {
      // Remove and cache any original content to act as a fallback
      let fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return {
        post: function (
          $scope: ng.IScope,
          $element: ng.IRootElementService,
          $attrs: ng.IAttributes,
          notUsed: {},
          $transclude: ng.ITranscludeFunction
        ) {
          if (!$transclude) {
            return;
          }

          $transclude(function (clone) {
            if (clone.length) {
              $element.replaceWith(clone);
            } else {
              fallbackLinkFn($scope, (clone: ng.IRootElementService) => {
                $element.replaceWith(clone);
              });
            }
          });
        }
      };
    }
  };
}
